import { render } from "./TermsConditionView.vue?vue&type=template&id=a0b56d9c&scoped=true"
import script from "./TermsConditionView.vue?vue&type=script&lang=js"
export * from "./TermsConditionView.vue?vue&type=script&lang=js"

import "./TermsConditionView.vue?vue&type=style&index=0&id=a0b56d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b56d9c"]])

export default __exports__